var constant = x => () => x;
export { constant as default };
//# sourceMappingURL=constant.js.map
